var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 45,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M24 0h36v45H24V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#060",
    d: "M0 0h24v45H0V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M31.8 28.7a50 50 0 0 1-17-10.1l.8-1.3c1.4 2 15.6 10.4 17 10.1l-.8 1.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m15.6 17.3 1.1 1 2 1.5a100.9 100.9 0 0 0 13.5 7.6h.3l-.6 1.3c-.5 0-1-.1-1.7-.4l-2.3-1A74.1 74.1 0 0 1 15 19l-.2-.3.8-1.3Zm0 0-.7 1.3s0 .2.2.3l.4.5 1.6 1.3a71.5 71.5 0 0 0 14.7 8l.7-1.2h-.4l-.6-.3-2-1a92.4 92.4 0 0 1-13.9-8.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M15.5 17.1c-.3.8 3.6 3.2 8.2 6 4.7 2.9 8.8 4.6 9 4.4l.2-.3a46.9 46.9 0 0 1-9-4.3 39 39 0 0 1-8.3-6l-.1.2Zm16.4 11.6-.3.1c-1.2-.1-4.6-1.8-8.7-4.2-4.7-2.8-8.6-5.4-8.1-6v-.3c-.3 1.2 7.8 5.8 8.3 6 4.6 3 8.6 4.7 9 4.2l-.2.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M15.6 16.9v.3l1 1 1.8 1.3 5.5 3.4c4 2.5 7.3 4 8.6 4.3h.4l-.1.3h-.3c-.2 0-.4 0-.6-.2l-2-.8-6.2-3.4A145.3 145.3 0 0 1 16 18l-.5-.5c0-.1-.1-.3 0-.4v-.2Zm-.1.3v.3l.5.5 1.8 1.3a145.3 145.3 0 0 0 12.1 7.1 23.5 23.5 0 0 0 2.8 1h.1l-.3-.1a47 47 0 0 1-8.7-4.4 126.6 126.6 0 0 1-7.2-4.7 4.3 4.3 0 0 1-1-1V17l-.1.1Zm-.7 1.1h.1v.3l.2.3.9.8 2.7 2 4 2.4.4.3a56.6 56.6 0 0 0 8.6 4.2h.3v.2h-.4l-1.3-.3-2-.9c-1.5-.7-3.3-1.8-5.4-3a96.7 96.7 0 0 1-7.7-5.2l-.4-.5c-.1-.2-.1-.3 0-.4v-.2Zm17 10.4h.1-.2a56.6 56.6 0 0 1-8.7-4.2l-.3-.3a102.7 102.7 0 0 1-6.8-4.5 6 6 0 0 1-.8-.8l-.2-.3v-.2l-.1.1v.4l.4.4 1.7 1.4a96.6 96.6 0 0 0 14.7 8l.2.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M24 19.4c3 0 6.8-.4 9-1.3l-.5-.7a24 24 0 0 1-8.5 1.2c-4 0-7-.4-8.4-1.4l-.4.9c2.6 1 5.3 1.3 8.8 1.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M15.6 17.2c.7.5 1.8.8 3.2 1a36.6 36.6 0 0 0 12.3-.3 5.9 5.9 0 0 0 1.4-.5l.4.7c-2.1 1-5.9 1.3-8.9 1.4v-.1c-3.5 0-6.2-.2-8.8-1.4l.4-.7c.7.5 1.8.8 3.2 1l5.2.4a44 44 0 0 0 7-.8 6 6 0 0 0 1.4-.5l.5.7a27 27 0 0 1-8.9 1.3m-8.4-2.2Zm0 0-.5.8.5-.8Zm8.4 2.3a21.9 21.9 0 0 1-8.9-1.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M33 18.2s-1.4.6-3.5 1a35.7 35.7 0 0 1-10.8 0c-2.1-.3-3.2-.8-3.7-1l.1-.2c1.2.5 2.4.8 3.7 1a38.6 38.6 0 0 0 10.7 0c2-.4 3.2-.9 3.4-1l.1.2Zm-.4-.8c-.2.2-1.3.6-3.3 1a36.4 36.4 0 0 1-10.3 0c-2-.3-3.1-.8-3.5-1v-.1c.4.1 1.4.6 3.5.8a36 36 0 0 0 10.2 0 8 8 0 0 0 3.3-1l.1.3Zm-18.5 5.7c1.8 1 6 1.5 9.9 1.5a27 27 0 0 0 10-1.5l-.1-1c-.6.9-5.5 1.7-10 1.7-4.4 0-8.5-.7-9.8-1.6v.9",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m32.5 17.1.2.3-.4.2-.7.2a36.4 36.4 0 0 1-7.6.9c-2 0-3.7-.1-5-.3-1.8-.2-2.8-.6-3.3-.8a8 8 0 0 0-.3-.1l.2-.2c.3.1 1.3.5 3.4.8a36 36 0 0 0 10.2 0 13.6 13.6 0 0 0 3.3-1Zm.1.3-.1-.2s-.2 0-.3.2l-.6.2a36 36 0 0 1-12.6.6c-2-.3-3-.7-3.4-.9l-.1.2h.2a35.2 35.2 0 0 0 8.3 1.1 36.4 36.4 0 0 0 8.3-1l.3-.2Zm.3.5.2.2v.1H33l-.2.1-.8.3-2.5.6a35.8 35.8 0 0 1-10.8 0c-2-.3-3.2-.8-3.6-1V18c1.2.5 2.4.7 3.7 1a36.7 36.7 0 0 0 13.1-.6 6 6 0 0 0 .9-.4l.1-.1Zm.1.3V18h-.1l-.2.1-.7.3a36.8 36.8 0 0 1-13.2.6 14 14 0 0 1-3.5-1l-.1.2c.5.2 1.6.6 3.6 1a35.7 35.7 0 0 0 14-.9 2.2 2.2 0 0 0 .3-.1Zm.9 4v1a42.3 42.3 0 0 1-10 1.5 33.3 33.3 0 0 1-9.8-1.6v-1c.7.5 2 .9 3.8 1.2a41.2 41.2 0 0 0 14.8-.6c.3 0 .6-.2.8-.3.2 0 .3-.2.3-.3ZM14 23c1 .5 2.4 1 4.2 1.2 1.7.2 3.7.4 5.7.4M14 23v-.8.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M34 23v.2c-.3.3-1.9.7-4 1a40.7 40.7 0 0 1-16-1v-.3c.9.6 3.3 1 4.2 1.2A38.6 38.6 0 0 0 34 22.9Zm0-1v.3c-.3.3-1.9.8-4 1.1a40.7 40.7 0 0 1-11.9 0c-1.4-.1-2.8-.5-4.1-1V22c.9.6 3.3 1 4.2 1.2A38.3 38.3 0 0 0 34 22.1Zm-10 6.5c-4.3 0-8-1.1-8.7-1.3l.5.9c2.7.9 5.4 1.3 8.2 1.3 3.3 0 6.1-.3 8.1-1.3l.6-1c-1.4.7-6 1.4-8.7 1.4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14 22a7 7 0 0 0 2.1.8 28 28 0 0 0 7.8.8c2.6 0 4.6-.2 6.1-.4a19.8 19.8 0 0 0 3.4-.8l.6-.3v.2l-.1.2-.3.1a40.7 40.7 0 0 1-15.5.9 14.6 14.6 0 0 1-4.2-1.2V22Zm20 .1-.6.3-1 .3-2.4.5a38.3 38.3 0 0 1-11.9 0 28 28 0 0 1-2-.4 8 8 0 0 1-2.1-.7v.2c1.3.6 2.7 1 4.1 1.1a40.7 40.7 0 0 0 12 0 24.7 24.7 0 0 0 3.7-1l.2-.1v-.2ZM14 23c.4.3 1.3.5 2.1.7a27.2 27.2 0 0 0 7.8.8A41 41 0 0 0 30 24a20.6 20.6 0 0 0 3.4-.8l.6-.3v.3l-.1.1-.3.1-.9.3-2.6.6A40.7 40.7 0 0 1 14 23.2v-.3Zm20 0c-.1.2-.3.3-.6.3-.2.2-.6.3-1 .4L30 24a41.1 41.1 0 0 1-11.8 0l-2.1-.4c-.8-.2-1.6-.5-2.1-.8v.2c1.3.6 2.7 1 4.1 1.2 2 .2 3.9.4 5.8.4a40.7 40.7 0 0 0 9.7-1.3l.2-.1.2-.2Zm-1.3 4.2-.6 1a21 21 0 0 1-8 1.3 23.4 23.4 0 0 1-8.3-1.3l-.6-1 .5.2c1.3.3 4.5 1.2 8.3 1.2a34.3 34.3 0 0 0 8.7-1.4ZM24 28.6c-3.8 0-7-1-8.3-1.3h-.4l.5.7c2.7 1 5.4 1.4 8.2 1.4 3.3-.1 6.1-.4 8-1.3l.6-.9a34.4 34.4 0 0 1-8.6 1.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "m32.3 27.9-.2.3c-1 .4-2.5.7-3 .8a24 24 0 0 1-13.4-1l-.2-.1h.2a26.9 26.9 0 0 0 16.6 0Zm.5-.9c0 .2 0 .3-.2.4-.5.2-1.8.6-3.8.8-1.3.2-2.2.4-4.8.4-3 0-6-.4-8.8-1.3l-.1-.2c3 .8 6 1.2 9 1.3 2.3 0 3.3-.2 4.7-.4 2.3-.4 3.4-.7 3.8-.9h.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M32.9 27a28.3 28.3 0 0 1-.2.4c-.6.2-2 .6-4 .9h-.5c-1 .2-2 .3-4.2.4a32.6 32.6 0 0 1-8.8-1.4l-.1-.2c3 .8 6 1.2 9 1.3 2 0 3.1-.2 4.2-.4h.4c2.2-.3 3.3-.7 3.8-.8l.3-.2Zm-.1 0-.2.2h-.1c-.5.1-1.6.5-3.7.8h-.5c-1 .2-2.1.4-4.3.4-3 0-6-.5-8.9-1.3l.1.2a32.5 32.5 0 0 0 13 1h.6c2-.4 3.3-.8 3.8-1l.2-.2Zm-17.3.8h.2a26.8 26.8 0 0 0 16.5 0h.1a13 13 0 0 1-.2.5l-3 .8c-1.7.3-3.4.4-5.1.4a24 24 0 0 1-8.4-1.4l-.1-.2Zm0 0 .2.2A24 24 0 0 0 29 29c.6 0 2.1-.4 3-.8l.2-.3c-.3.2-1.1.5-3.3 1a26.9 26.9 0 0 1-13.2-1h-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M32.9 22.3c0 2.8-1.4 5.3-2.6 6.4a9.3 9.3 0 0 1-6.4 2.7 9.5 9.5 0 0 1-6.2-2.6 9.5 9.5 0 0 1-2.6-6.4 9 9 0 0 1 3.2-6.6 9.3 9.3 0 0 1 6-2.2 9.2 9.2 0 0 1 6.6 3.4c1.2 1.4 1.7 3 2 5.3Zm-9-9.6a10 10 0 0 1 9.2 13.6A10 10 0 1 1 24 12.7Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M31 15.6a9.9 9.9 0 0 0-16.8 7 9.9 9.9 0 1 0 16.7-7Zm-7-3a10 10 0 0 1 10 10 10 10 0 1 1-10-10Zm.3 1c-2.2 0-4.3.8-6 2.2a9 9 0 0 0-3.1 6.6c0 2.4 1 4.6 2.5 6.3a8.6 8.6 0 0 0 6.2 2.6c2.4 0 4.7-1 6.4-2.6a9.6 9.6 0 0 0 2.6-6.4 9.3 9.3 0 0 0-2-5.3 9.2 9.2 0 0 0-6.6-3.3Zm8.6 8.7a9.4 9.4 0 0 0-2-5.4 9.2 9.2 0 0 0-6.6-3.3c-2.2 0-4.4.7-6 2.1a9 9 0 0 0-3.2 6.7c0 2.4 1 4.7 2.6 6.4.4.4 1.2 1 2.3 1.6 1.1.6 2.5 1 4 1a9 9 0 0 0 6.3-2.7",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M24 12.6a10 10 0 0 1 0 19.8 10 10 0 0 1 0-19.8Zm-9.7 9.9c0 5.3 4.4 9.7 9.7 9.7 5.3 0 9.7-4.4 9.7-9.7 0-5.3-4.4-9.7-9.7-9.7a9.7 9.7 0 0 0-9.7 9.7Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M24 12.6a9.9 9.9 0 1 0 0 19.8 9.9 9.9 0 0 0 0-19.8Zm0 0a10 10 0 0 1 0 19.8 10 10 0 0 1 0-19.8Zm-9.7 9.9c0-5.3 4.4-9.7 9.7-9.7 5.3 0 9.7 4.4 9.7 9.7 0 5.3-4.4 9.7-9.7 9.7a9.8 9.8 0 0 1-9.7-9.7Zm9.7-9.7a9.7 9.7 0 0 0-9.7 9.7c0 5.3 4.4 9.7 9.7 9.7a9.7 9.7 0 0 0 0-19.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M24 13.4A9 9 0 0 1 30.4 29a9.1 9.1 0 0 1-6.4 2.7 9.1 9.1 0 0 1 0-18.1Zm-8.8 9.1c0 4.9 4 8.9 8.8 8.9a8.9 8.9 0 1 0-6.2-15.1 8.9 8.9 0 0 0-2.6 6.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M30.4 16.1a9 9 0 0 0-12.8 0 9 9 0 0 0-2.6 6.4c0 5 4 9 9 9a9 9 0 0 0 6.4-15.4ZM24 13.4a9.1 9.1 0 0 1 9 9.1 9.1 9.1 0 0 1-9 9.1 9 9 0 0 1-9-9.1 9.1 9.1 0 0 1 9-9Zm0 .2a9 9 0 0 1 8.9 8.9 9 9 0 0 1-8.9 8.9 9 9 0 0 1-8.9-8.9 9 9 0 0 1 8.9-8.9Zm-8.8 8.9c0 4.9 4 8.8 8.8 8.8 4.8 0 8.8-4 8.8-8.8a8.9 8.9 0 0 0-15-6.2 8.9 8.9 0 0 0-2.6 6.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M24.4 12.6h-.9v19.9h.9v-20Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M23.5 12.6h.9v19.9h-.9v-20Zm0 0v19.8h.9V12.6h-.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M24.3 12.4h.2v20.2h-.2V12.4Zm-.8 0h.2v20.2h-.2V12.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M23.4 12.4h.3v20.2h-.2V12.5Zm.1 0v20.1h.2v-20h-.2Zm.8 0h.2v20.2h-.2V12.5Zm0 0v20.1h.2v-20h-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M33.9 22.9v-.7l-.6-.6-3.4-.9-4.9-.5-5.9.3-4.2 1-.8.6v.8l2.1-1 5.1-.8h4.9l3.6.4 2.5.6 1.6.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m25 20.2 4.9.5 3.4.9.6.5v.8l-1.6-.8-2.5-.6-3.6-.4h-4.9l-5 .8-2.2 1V22l.8-.6 4.2-1 5.9-.3Zm-5.9.3-4.2 1-.8.6v.7l2-1h.1l5.1-.7h4.9l3.6.4 2.5.6 1.6.7v-.6l-.6-.6-3.4-.9-4.9-.5-5.9.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M24 21c2.3 0 4.6.2 6.4.5 1.9.4 3.2.9 3.6 1.4v.3c-.5-.7-2.3-1.2-3.6-1.4a35.3 35.3 0 0 0-13 0c-1.3.3-3.2.8-3.4 1.4v-.3c0-.4 1.5-1 3.5-1.3 1.7-.4 4-.6 6.5-.6Zm0-.9c2.1 0 4.3.2 6.4.6 1.9.4 3.2.8 3.6 1.4v.2c-.5-.6-2.3-1.1-3.6-1.4a34.5 34.5 0 0 0-12.9 0c-1.4.3-3.3.9-3.5 1.4V22c.1-.3 1.5-1 3.5-1.3 1.7-.3 4-.6 6.5-.6Zm0-4.3c3.6 0 6.8.5 8.3 1.3l.6.9a22 22 0 0 0-9-1.3c-3.3 0-7 .4-8.8 1.3l.7-1c1.5-.8 5-1.2 8.1-1.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29 16.2a26 26 0 0 0-5-.4m5 .4c1.4.2 2.6.5 3.3.9L29 16Zm3.3.9.5.8a18 18 0 0 0-3.3-.9A40.5 40.5 0 0 0 19 17a11 11 0 0 0-3.8 1l.6-1c.7-.4 2-.7 3.4-.9a37 37 0 0 1 4.7-.3m0 0c-1.5 0-3.2 0-4.7.3a11.5 11.5 0 0 0-3.4.9l-.7 1c1-.4 2.3-.8 3.9-1a39.5 39.5 0 0 1 10.5.1 11.8 11.8 0 0 1 3.4.9l-.6-1c-.7-.3-1.9-.7-3.3-.9-1.5-.2-3.2-.3-5-.3Zm6.5 5a35.1 35.1 0 0 0-13 0 14.3 14.3 0 0 0-3 1l-.3.1-.1.2v.1l.1-.1.3-.2c.2-.2.6-.3.9-.4a35.3 35.3 0 0 1 15-.6 17 17 0 0 1 3.1 1c.3 0 .4.2.6.3v-.1c-.2-.3-.7-.5-1.3-.8l-2.3-.6ZM24 20c2.1 0 4.3.2 6.4.6l2.3.6a3.2 3.2 0 0 1 1.3.8v.2a2 2 0 0 0-.6-.4l-1-.4-2-.6a35.2 35.2 0 0 0-15 .6 5.7 5.7 0 0 0-1.3.6l-.1.2V22l.3-.2.7-.3a35.2 35.2 0 0 1 9-1.3Zm0 1a35 35 0 0 0-9 1.2 4.5 4.5 0 0 0-1 .5v.3c0-.2.2-.3.4-.4l.9-.4 2.2-.5a35.6 35.6 0 0 1 12.9 0 17.8 17.8 0 0 1 3 .9l.6.4v-.2c-.2-.2-.7-.5-1.3-.7l-2.3-.6c-1.8-.4-4-.6-6.4-.6Zm-6.5.4a35.2 35.2 0 0 1 13 0l2.2.6a3.3 3.3 0 0 1 1.3.8v.3a2 2 0 0 0-.6-.5l-1-.4-2-.5a35.3 35.3 0 0 0-15.1.6l-.9.4c-.2.1-.4.2-.4.4v-.5l.3-.1.7-.4 2.5-.7Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M24 16.6a26.9 26.9 0 0 1 8.9 1.3l.1.3c-.4-.3-1.7-.7-3.3-1-1.6-.3-3.6-.4-5.7-.4-2.4 0-4.2.1-5.8.4-1 .1-2.1.5-3.1 1l.1-.3c.6-.3 1.5-.7 3-1 1.6-.2 3.5-.3 5.8-.3Zm0-.9c2 0 4 .1 5.5.4 1 .1 2 .5 3 1l.1.3c-.3-.4-1.8-.9-3.2-1a34.7 34.7 0 0 0-11 0c-1 0-1.9.4-2.8.8l.3-.3c.5-.3 1.4-.6 2.5-.8 1.8-.3 3.7-.4 5.6-.4Zm5 11a26 26 0 0 0-5-.4c-6.1 0-8.1 1.2-8.4 1.6l-.4-.8a26.5 26.5 0 0 1 14.1-1.2l-.4.7",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M18.4 16.2c-1.1.2-2 .4-2.5.7l-.2.2c.9-.4 1.8-.7 2.7-.8a34.7 34.7 0 0 1 13 .4 6 6 0 0 1 1.1.6l-.1-.2a9 9 0 0 0-2.9-1 31 31 0 0 0-5.5-.4c-1.9 0-3.8.2-5.6.5Zm5.6-.5c-1.9 0-3.8.1-5.6.4a10.2 10.2 0 0 0-2.6.8l-.2.3a9 9 0 0 1 2.8-.8 33.8 33.8 0 0 1 11 0 14.5 14.5 0 0 1 2.8.7l.4.3-.2-.4a9 9 0 0 0-2.9-1 31 31 0 0 0-5.5-.3Zm5.7 1.3c-1.9-.3-3.8-.4-5.7-.4-2.3 0-4.2 0-5.8.4-1.5.3-2.4.6-3 .9v.2c.9-.5 2-.8 3-1 1.6-.2 3.4-.3 5.8-.3a32 32 0 0 1 7.8.8c.5.2 1 .3 1.2.5l-.1-.2h-.2l-.2-.2-.7-.2-2-.5Zm-5.7-.5c-2.3 0-4.2.1-5.9.4a10.7 10.7 0 0 0-2.9 1l-.1.2c1-.4 2-.7 3.1-.9 1.6-.3 3.4-.4 5.8-.4a31.9 31.9 0 0 1 7.8.9 5.3 5.3 0 0 1 1.3.5l-.2-.3-.1-.1-.3-.1-.7-.3-2-.5c-2-.3-3.9-.4-5.8-.4Zm-8.8 10.6.4.7.6-.3 1.4-.6a26.4 26.4 0 0 0 0 .1l-1.4.5-.5.4h-.1l-.5-.8c.8-.6 2-1 3.6-1.3a31.2 31.2 0 0 1 10.7.1l-.5.7m.4-.7-.4.7.4-.7Zm0 0Zm0 0a27.3 27.3 0 0 0-10.6 0 9 9 0 0 0-3.5 1.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M24 26.1c1.7 0 3.3.1 5 .4l-.2.2a35.3 35.3 0 0 0-11.4.4c-.6.2-1.7.6-1.8 1v-.2c0-.2.6-.6 1.8-1 2.2-.6 4.4-.7 6.6-.8Zm0-.8c1.8 0 3.6.1 5.4.5l-.1.2a28 28 0 0 0-12.1.3c-.7.2-2 .7-2 1l-.1-.2c0-.3 1-.7 2-1 2.2-.6 4.6-.8 7-.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29.4 25.8A30.6 30.6 0 0 0 17 26a9.8 9.8 0 0 0-1.8.8l-.1.1v.2l.2-.2.5-.3 1.3-.4a28 28 0 0 1 12.1-.4v-.1Zm-5.4-.5a30.7 30.7 0 0 1 5.4.5v.2h-.1a28 28 0 0 0-5.3-.5 25 25 0 0 0-8 1.3c-.3 0-.4.2-.6.3l-.1.1v.1h-.1l-.1-.2V27l.2-.2.4-.2 1.4-.5c2.2-.7 4.6-.8 7-.8Zm0 .8a30.2 30.2 0 0 1 5 .5l-.1.2a26.7 26.7 0 0 0-11.5.4 7.6 7.6 0 0 0-1.5.6l-.2.3h-.1l-.1-.2.1-.2.4-.3 1.3-.5a26 26 0 0 1 6.7-.8Zm0 0a21.5 21.5 0 0 0-8 1.4 2 2 0 0 0-.3.2l-.2.2.1.1.2-.2.5-.3 1.1-.4c2-.6 4.3-.8 6.6-.8 1.7 0 3.3.1 4.8.4l.1-.1c-1.6-.3-3.2-.4-5-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "m32.8 27.2-.8 1.2-2.1-1.9-5.5-3.7-6.2-3.4-3.2-1.1.7-1.3.2-.1 2 .5 6.6 3.4 3.8 2.4 3.2 2.3 1.3 1.5v.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m15.9 16.9 2 .5 6.6 3.4 3.8 2.4 3.2 2.3 1.3 1.5v.2l-.8 1.2-2.1-1.9-5.5-3.7-6.2-3.4-3.2-1v-.1l.6-1.3.3-.1Zm0 0-.2.1-.7 1.3 3.2 1 6.2 3.5 5.5 3.7 2.1 1.8.7-1V27l-1.2-1.5-3.2-2.3-3.8-2.4-6.6-3.4-2-.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    fillRule: "evenodd",
    d: "M14.9 18.3a27 27 0 0 1 9 4.1c4.3 2.6 8.5 5.6 8.1 6.2l-.1.2v-.3c-.2-.6-3.2-3-8-5.9-4.8-2.8-8.8-4.5-9.2-4l.2-.3Zm18 9c.4-.8-3.5-3.7-8.3-6.5-4.8-2.8-8.4-4.4-9-4l-.1.4c.1-.2.3-.2.4-.2a31 31 0 0 1 8.7 4c2 1.2 8.2 5.2 8.2 6.3v.2l.1-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M18.5 17.6a62.8 62.8 0 0 1 14 8.7l.4.5v.4l-.1.3v-.1l-.1-.3-.2-.3-.7-.8-2.4-1.8a69.3 69.3 0 0 0-12.3-6.9l-1.2-.3h-.2l-.2.1V17l.5-.1h.6l2 .8Zm14.3 9.7c.1-.2.1-.3 0-.4 0-.2-.2-.4-.4-.6l-1.7-1.5a62.8 62.8 0 0 0-14.7-8l-.4.1v.1h.3a20.8 20.8 0 0 1 3.1 1 74.7 74.7 0 0 1 12.8 8 6.4 6.4 0 0 1 1 1 .6.6 0 0 1 0 .3Zm-18-9v.2h1l2 .8a70.7 70.7 0 0 1 14 8.9l.2.3v.2-.2h.1v-.2a79.2 79.2 0 0 0-16-9.8 4 4 0 0 0-1-.2H15Zm0 0h.4l.7.1 2 .8A58.4 58.4 0 0 1 32 28.6v.2h-.1v-.3l-.3-.3-.4-.4-1.6-1.3a70.7 70.7 0 0 0-14-7.9h-.7v-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 23.6a5.9 5.9 0 0 0 1.8 4.2A5.9 5.9 0 0 0 30 23.6v-8H18.1v8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M18 15.6h12v8a6 6 0 0 1-1.8 4.2m-8.4 0a6 6 0 0 0 4.2 1.8 6 6 0 0 0 4.2-1.8m-8.4 0a5.9 5.9 0 0 1-1.8-4.2v-8m.1 8a5.8 5.8 0 0 0 1.7 4.1 5.9 5.9 0 0 0 8.4 0 5.9 5.9 0 0 0 1.7-4v-8H18.1v7.9Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M18.3 23.6a5.6 5.6 0 0 0 1.7 4 5.7 5.7 0 0 0 9.2-1.8c.3-.7.5-1.4.5-2.2V16H18.3v7.7m9.1-5.4v5.4a3.3 3.3 0 0 1-1 2.4c-.6.7-1.5 1-2.4 1a3.4 3.4 0 0 1-3.4-3.4v-5.4h6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M18.3 16h11.4v7.6a5.7 5.7 0 0 1-5.7 5.7 5.7 5.7 0 0 1-5.7-5.7V16Zm0 7.6a5.6 5.6 0 0 0 1.7 4 5.7 5.7 0 0 0 9.2-1.8c.3-.7.4-1.4.4-2.2V16H18.3v7.6Zm2.3-5.4h6.8v5.4a3.3 3.3 0 0 1-1 2.5c-.6.6-1.5 1-2.4 1a3.4 3.4 0 0 1-3.4-3.4v-5.5Zm0 0v5.4c0 1 .4 1.8 1 2.4a3.3 3.3 0 0 0 4.8 0 3.3 3.3 0 0 0 1-2.4v-5.3h-6.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    d: "M19 18c0-.6.4-.7.4-.7s.5.1.5.7H19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    d: "M18.7 17.3v.6h.3c0-.5.4-.6.4-.6s.4.1.4.6h.5l-.1-.6h-1.5Zm-.1.6h1.7v.2h-1.7V18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M18.7 17.2h1.5v.7h.2l-.1.2h-1.7l-.1-.1v-.1l.2-.6Zm0 0v.7h.3c0-.3.1-.4.2-.5a.6.6 0 0 1 .2-.1h-.7Zm.7.1Zm0 0h.1l.2.1s.2.2.2.5h.3v-.6h-.7Zm.4.6c0-.2 0-.4-.2-.5a.6.6 0 0 0-.2 0h-.2l-.1.5h.7Zm-1.2 0v.1h1.7-1.7Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    d: "M19.2 17.9c0-.3.2-.4.2-.4s.3 0 .3.4h-.5Zm-.6-.9h1.7v.1h-1.7V17Zm.6 1h1v.1h-1.6.6Zm.5-1h.6v.2h-.5V17Zm.5.3v.6h-.4v-.6h.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.1 17h.2v1h-.5v-.7h-1.2V17h1.5Zm0 0Zm0 0v.1h.1-.4.2Zm-.2 0Zm-.2 0h-1.1v.1h1.1Zm0 .2h.5-.4Zm.2 0v.7h.3v-.6h-.3Zm-.5.3Zm0 0-.2.4h.4v-.3a.4.4 0 0 0-.2 0Zm0 0h.2v.4h-.4l.1-.3a.4.4 0 0 1 .1-.1Zm-.8.6h1.6-1.5Zm0 0h1.6v.1h-1.6V18Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    d: "M19.1 16.7v.3h-.4v-.3h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M18.7 16.6h.4v.4h-.4v-.4Zm0 0v.4h.4v-.3h-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    d: "M18.6 16.4h.1v.1h.1v-.1h.2v.1-.1h.2v.2h-.5v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M18.7 16.4v.2h.4v-.2.1h-.4Zm0 0h.5v.2h-.5v-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.4 16.6c0-.1 0-.1 0 0v.1-.1Zm-.5.2v.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#039",
    d: "M23.3 22.7a.8.8 0 0 0 .4.8h.3c.2 0 .4 0 .5-.2.2-.1.3-.3.3-.6v-1h-1.5v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.6 22.2a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3Zm.8 0a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3Zm-.4.4a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3Zm-.4.4a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3Zm.8 0a.1.1 0 1 0 0-.3.1.1 0 0 0 0 .3Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/pt.669ddf2f400bfba31d0ad860a90dd2d0.svg";
export { ForwardRef as ReactComponent };